<template>
  <el-dialog :visible.sync="dialogVisible" width="60%"  top="5vh" :title="$t('fund.vulnerable')" custom-class="sign-dialog" :close-on-click-modal="false" @close="returnPage" @closed="returnPage">
    <div class="statement-content">
      <div v-for="(item, index) in $t('fund.statement')" :key="index" class="card">
        <p class="content">{{ !isEnglish ? item.en : item.zh }}</p>
        <p v-if="!isEnglish" class="description">{{ item.zh }}</p>
      </div>
    </div>
    <div class="sign-content">
      <div class="title-wrap">
        <div class="sign-title">{{ $t('fund.signTitle')}}</div>
      </div>
      <canvas class="canvas" id="signContent" ref="signContent"  :style="{'background':isShowSample?`url(${showSignatureImg}) no-repeat center`:'#fff'}"></canvas>
    </div>
    <div class="actionsWrap" slot="footer">
      <div class="actions">
        <el-button class="back" inline type="default"  @click="returnPage">{{ $t('common.cancel')}}</el-button>
        <el-button inline type="default"  class="resign" @click="handleClear">{{ $t('common.resign')}}</el-button>
        <el-button inline type="primary"  @click="handleCommit">{{ $t('fund.readAndSigned')}}</el-button>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import { mapState } from 'vuex'
import signature from '@/assets/images/signature_sample.png'
import signatureHant from '@/assets/images/signature_sample_hant.png'
import signatureEn from '@/assets/images/signature_sample_en.png'
import SmoothSignature from 'smooth-signature'
// import { Toast, Dialog } from 'mand-mobile'
export default {
  name: 'sign',
  data() {
    return {
      showFull: true,
      isFirst: true,
      dialogVisible: false,
      isShowSample: true
    }
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    visible: {
      handler(val) {
          this.dialogVisible = val
          if (val) {
             this.$nextTick(() => {
                this.initSignature()
              })
          }
      }
    }
  },
  computed: {
    ...mapState(['selectLang', 'theme', 'accountNumber', 'klineTheme']),
    showSignatureImg() {
      let langType = this.selectLang || 'cn'
      const langTypeObj = {
        'cn': signature,
        'hk': signatureHant,
        'en': signatureEn
      }
      return langTypeObj[langType]
    },
    isEnglish() {
      return this.selectLang === 'en'
    }
  },
  mounted() {
    this.$nextTick(() => {
      // this.initSignature()
    })
  },
  methods: {
    initSignature() {
      const canvas = this.$refs.signContent
      const options = {
        minWidth: 2,
        maxWidth: 6,
        height: 220,
        onStart: this.onStart
        // bgColor: '#fff'
      }
      this.signature = new SmoothSignature(canvas, options)
    },
    onStart() {
      this.isShowSample = false
    },
    handleClear() {
      this.isShowSample = true
      this.signature.clear()
    },
    handleUndo() {
      this.signature.undo()
      const isEmpty = this.signature.isEmpty()
      if (isEmpty) {
        this.isShowSample = true
      }
    },
    handleRedo() {
      this.signature.redo()
    },
    handleFull() {
      this.showFull = !this.showFull
    },
    toImg() {
      // const isEmpty = this.signature.isEmpty()
      // if (isEmpty) {
      //   return
      // }
      // const pngUrl = this.signature.getPNG()
    },

    handleColor() {
      this.signature.color = this.getRandomColor()
    },
    getRandomColor() {
      return '#' + Math.random().toString(16).slice(-6)
    },
    returnPage() {
      // this.$router.go(-1)
      this.$emit('update:visible', false)
    },
    handleCommit() {
      const isEmpty = this.signature.isEmpty()
      if (isEmpty) {
        this.$message({
          message: this.$t('fund.pleaseSign'),
          type: 'error'
        })
        return
        // Toast.info(this.$t('fund.pleaseSign'))
      }
      this.$alert(this.$t('fund.weWillCallyou'), '', {
          confirmButtonText: this.$t('common.knowIt')
      }).then(() => {
        const canvas = this.$refs.signContent
        const pngUrl = this.cropAndResizeSignature(canvas, 150)
        this.$emit('confirm', pngUrl)
      }).catch(() => {
          // this.$emit('update:visible', false)
      })
    },
    // 添加裁剪和调整大小的方法
    cropAndResizeSignature(canvas, targetHeight) {
      // 获取签名的边界
      const ctx = canvas.getContext('2d')
      const pixels = ctx.getImageData(0, 0, canvas.width, canvas.height)
      const data = pixels.data

      let minX = canvas.width
      let minY = canvas.height
      let maxX = 0
      let maxY = 0

      // 查找签名的边界
      for (let y = 0; y < canvas.height; y++) {
        for (let x = 0; x < canvas.width; x++) {
          const i = (y * canvas.width + x) * 4
          // 检查像素是否不透明（签名部分）
          if (data[i + 3] > 0) {
            minX = Math.min(minX, x)
            minY = Math.min(minY, y)
            maxX = Math.max(maxX, x)
            maxY = Math.max(maxY, y)
          }
        }
      }

      // 添加一些边距
      const padding = 10
      minX = Math.max(0, minX - padding)
      minY = Math.max(0, minY - padding)
      maxX = Math.min(canvas.width, maxX + padding)
      maxY = Math.min(canvas.height, maxY + padding)

      // 计算裁剪区域的宽度和高度
      const width = maxX - minX
      const height = maxY - minY

      // 如果没有签名内容，返回原始画布
      if (width <= 0 || height <= 0) {
        return canvas.toDataURL()
      }

      // 创建一个新的画布用于裁剪
      const croppedCanvas = document.createElement('canvas')
      const croppedCtx = croppedCanvas.getContext('2d')

      // 计算新的宽度，保持宽高比
      const targetWidth = Math.round((width / height) * targetHeight)

      // 设置裁剪画布的大小
      croppedCanvas.width = targetWidth
      croppedCanvas.height = targetHeight

      // 绘制裁剪后的图像
      croppedCtx.drawImage(
        canvas,
        minX, minY, width, height,
        0, 0, targetWidth, targetHeight
      )

      // 返回裁剪后的图像的 base64 数据
      return croppedCanvas.toDataURL()
    }
  }
}
</script>

<style lang="scss" scoped>
.sign-content {
  background: var(--gray_05);
  button {
    font-size: 28px;
    margin-right: 40px;
    width: 240px;
    border-radius: 46px;
  }
  .back{
    width: 240px;
  }
 .canvas {
    width: 100%;
    border-radius: 10px;
    margin-top: 12px;
    background-size: contain !important;
    border: 2px dashed #ccc;
  }

  .actions {
    margin-bottom: 40px;
    white-space: nowrap;
  }
  .title-wrap{
    margin-top: 10px;
  }
  .sign-title{
    width: 100%;
    color: #1C212A;
    font-size: 16px;
  }

}
.international.app .resign.el-button.default {
  color: var(--brand_01);
  border-color: var(--brand_01);
  border-width: 1px;
}
.international.app .el-button.default::after{
  border: 0;
}
.description {
  padding-left: 10px;
  background-color: #F7F8FA;
  color: #83909D;
  line-height: 30px;
}
.statement-content{
  height: 360px;
  overflow-y: scroll;
}
/deep/ .el-dialog__body{
  padding: 15px 20px;
}
/deep/ .sign-dialog{
  max-width: 720px !important;
}

</style>
